import React, { lazy, Component } from 'react';
import { ClockIcon, UtensilsIcon, PiggyBankIcon, HeartIcon } from 'lucide-react';
// Componente de imagen con lazy loading
const LazyImage = ({
  src,
  alt,
  className
}) => {
  return <img src={src} alt={alt} className={className} loading="lazy" data-id="element-83" />;
};
export function Features() {
  return <section id="caracteristicas" className="py-16 bg-white" data-id="element-84">
      <div className="container mx-auto px-4" data-id="element-85">
        <h2 className="text-3xl font-bold text-center text-amber-800 mb-12" data-id="element-86">
          Un ebook creado por mamás reales, para mamás reales
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-87">
          <FeatureCard icon={<ClockIcon className="h-10 w-10 text-amber-600" data-id="element-89" />} title="Listas en 15 minutos" description="20 recetas express que realmente puedes preparar en menos de 15 minutos" data-id="element-88" />
          <FeatureCard icon={<UtensilsIcon className="h-10 w-10 text-amber-600" data-id="element-91" />} title="Sin horno" description="Opciones que solo requieren estufa, microondas o se preparan en frío" data-id="element-90" />
          <FeatureCard icon={<PiggyBankIcon className="h-10 w-10 text-amber-600" data-id="element-93" />} title="Económicas" description="Ingredientes simples, accesibles y económicos que ya tienes en casa" data-id="element-92" />
          <FeatureCard icon={<HeartIcon className="h-10 w-10 text-amber-600" data-id="element-95" />} title="Nutritivas" description="Snacks y comidas nutritivas que los niños realmente comen y disfrutan" data-id="element-94" />
        </div>
        <div className="mt-16 flex justify-center" data-id="element-96">
          <LazyImage src="https://uploadthingy.s3.us-west-1.amazonaws.com/hWYzf9qG5NZun4tjSm6m3M/Generated_Image_September_11%2C_2025_-_5_22PM.png" alt="Colección de libros de recetas" className="w-full max-w-3xl rounded-lg shadow-lg" data-id="element-97" />
        </div>
      </div>
    </section>;
}
function FeatureCard({
  icon,
  title,
  description
}) {
  return <div className="bg-amber-50 p-6 rounded-lg text-center hover:shadow-md transition" data-id="element-98">
      <div className="mb-4 flex justify-center" data-id="element-99">{icon}</div>
      <h3 className="text-xl font-semibold text-amber-800 mb-2" data-id="element-100">{title}</h3>
      <p className="text-amber-700" data-id="element-101">{description}</p>
    </div>;
}